// Support mailbox used by the error toast's "send mail to support" action.
export const SUPPORT_EMAIL = 'support@lopfunds.com';
